import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Clinic } from 'src/app/models/database/clinic';
import { Employee } from 'src/app/models/database/employee';
import { LogOut, SetClinic, SetClinicToken, SetEmployee } from '../state/session.actions';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    private store: Store
  ) { }

  logout(): void {
    this.store.dispatch(new LogOut())
  }

  get loggedEmployee(): Employee {
    return this.store.snapshot().session.employee
  }

  set loggedEmployee(value: Employee) {
    this.logout()
    this.store.dispatch(new SetEmployee(value))
  }

  get clinic(): Clinic {
    return this.store.snapshot().session.clinic ?? null
  }

  set clinic(clinic: Clinic) {
    if (clinic) {
      this.store.dispatch(new SetClinic(clinic))
    }
  }

  get clinicToken(): string {
    return this.store.snapshot().session.clinicToken
  }

  set clinicToken(value) {
    this.store.dispatch(new SetClinicToken(value))
  }
}